var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgSharePlaylist = function SvgSharePlaylist(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "share-playlist_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#share-playlist_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.661 10.4c4.62 0 8.537 3.022 9.897 7.205a1.823 1.823 0 0 0-.134-.005c-.593 0-1.154.279-1.477.726a1.478 1.478 0 0 0-.05 1.674c.203.318.523.567.907.698a1.9 1.9 0 0 0 .62.102h2.033c.554 0 1.006-.452.961-1.004C28.883 13.192 23.375 8 16.661 8 9.946 8 4.44 13.192 3.904 19.796c-.045.552.407 1.004.961 1.004H6.9a1.97 1.97 0 0 0 .621-.102c.384-.131.704-.38.906-.698a1.48 1.48 0 0 0-.05-1.674c-.323-.447-.884-.725-1.477-.726-.045 0-.09.002-.135.005 1.36-4.183 5.277-7.205 9.897-7.205Zm6.4 8.8a6.4 6.4 0 1 1-12.8 0 6.4 6.4 0 0 1 12.8 0ZM3.922 36.366a.897.897 0 0 0 .51.924C7.926 39 12.134 40 16.661 40c4.529 0 8.736-.999 12.232-2.71a.897.897 0 0 0 .509-.924c-.664-4.7-6.115-8.366-12.74-8.366s-12.076 3.666-12.74 8.366ZM31.602 36c0 .665-.098 1.315-.284 1.943.575.038 1.157.057 1.745.057 3.93 0 7.586-.86 10.63-2.337a.884.884 0 0 0 .506-.922c-.631-4.075-5.376-7.241-11.136-7.241-2.232 0-4.312.476-6.06 1.295C29.838 30.615 31.6 33.17 31.6 36Zm-2.184-11.948c1.3-1.777 2.044-3.845 2.044-6.052 0-1.164-.207-2.29-.594-3.354a5.6 5.6 0 1 1-1.45 9.405Zm.484-11.387a11.868 11.868 0 0 0-1.315-1.731c1.37-.6 2.884-.934 4.475-.934 5.833 0 10.624 4.478 11.152 10.197.05.551-.402 1.003-.956 1.003h-1.653a1.716 1.716 0 0 1-.543-.09 1.518 1.518 0 0 1-.793-.61 1.295 1.295 0 0 1 .043-1.465c.283-.391.774-.634 1.293-.635.039 0 .078.001.117.004-1.19-3.66-4.618-6.304-8.66-6.304-1.111 0-2.175.2-3.16.565Z",
    fill: "currentColor"
  }))));
};
export default SvgSharePlaylist;